import { render, staticRenderFns } from "./RecordChart.vue?vue&type=template&id=7f034174"
import script from "./RecordChart.vue?vue&type=script&lang=js"
export * from "./RecordChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports